import { configureStore } from "@reduxjs/toolkit"
import cartReducer from "../features/cart/cartSlice"
import invoiceReducer from "../features/invoicesRegistry/invoiceSlice"
import reqReducer from "../features/req/reqSlice"
import orderReducer from "../features/order/orderSlice"

export const store = configureStore({
    reducer: { cart: cartReducer, invoicesRegistry: invoiceReducer, req: reqReducer, order: orderReducer },
})
